var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModalHoldOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    stroke: "#46C35F",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3771 45.117C73.0453 45.2379 72.7312 45.4036 72.4465 45.6128C70.9753 46.6954 68.2323 49.6526 68.2323 49.6526C68.3166 49.5734 66.2571 51.566 64.3688 53.4067C63.8392 53.9235 62.9488 53.5522 62.9424 52.812V28.9616C62.9424 26.6238 61.0518 25.0111 58.7639 25.4918C56.9384 25.8754 55.9643 27.5737 55.9643 29.6043L55.9803 47.6082L53.1975 47.6146V23.2501C53.1975 21.0194 51.4068 19.5551 49.2493 20.1227C47.7689 20.5118 47.0759 21.9052 47.0759 23.6621V47.648L44.3014 47.654L44.2853 28.1651C44.2853 26.2178 43.3671 24.5003 41.4207 24.4426C39.3978 24.3826 38.4237 26.0796 38.4237 28.0891L38.3948 47.686L35.6826 47.6915V34.8466C35.6826 32.8233 34.7414 31.2949 32.7071 31.2949C30.6833 31.2949 29.7422 32.8233 29.7422 34.8466L29.7445 63.3621C30.7593 78.0225 39.0471 80 47.7108 80C54.8885 80 60.6307 76.4395 63.8094 70.7481C64.2187 70.088 65.3246 68.3485 66.6361 66.2881C68.5015 63.358 70.1943 60.7364 71.3822 58.8788C72.9482 56.4293 74.3819 54.5158 76.1553 52.2119C76.6488 51.571 77.0576 51.0551 77.2526 50.8418C77.7868 50.2586 78.1388 49.5331 78.2441 48.7498V48.602C78.2441 45.7744 76.0326 44.1466 73.3771 45.117Z",
    fill: "#46C35F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalHoldOn);
export default __webpack_public_path__ + "static/media/modal-hold-on.cc6f73e6627464075c6032bf6ac54996.svg";
export { ForwardRef as ReactComponent };